import React from 'react';

const SuspiciousLinkWarning = ({ visible, message }) => {
  if (!visible) return null;

  return (
    <div className="chat-link-warning" role="alert">
      <strong>Suspicious link detected.</strong>
      {message && <span className="chat-link-warning__text"> {message}</span>}
    </div>
  );
};

export default SuspiciousLinkWarning;
